import React, { useState } from 'react';
import TimeframeChooser from './TimeframeChooser';
import AddchartIcon from '@mui/icons-material/Addchart';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmationModal from '../../../../common/ConfirmationModal';
import './ChartToolbar.css';

const ChartToolbar = ({
    darkMode,
    selectedTimeframe,
    handleTimeframeChange,
    handleRefresh,
    isControlsDisabled = false,
    onFullscreenToggle,
    isFullscreen = false,
    // Trade creation props
    isCreatingTrade = false,
    onStartTradeCreation,
    onCancelTradeCreation,
    tradeCreationInstruction = '',
    // Trade line dragging props
    isDraggingLine = false,
    draggingLineName = null,
    hasTradeLines = false,
}) => {
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const handleNewTradeClick = () => {
        if (hasTradeLines) {
            setIsConfirmOpen(true);
        } else {
            onStartTradeCreation();
        }
    };

    const handleConfirmNewTrade = () => {
        onStartTradeCreation();
    };

    return (
        <div className={`ntc-chart-toolbar ${darkMode ? 'ntc-chart-toolbar-dark' : 'ntc-chart-toolbar-light'}`}>
            <div className={`ntc-timeframe-container ${isControlsDisabled ? 'controls-disabled' : ''}`}>
                <TimeframeChooser
                    selectedTimeframe={selectedTimeframe}
                    onTimeframeChange={handleTimeframeChange}
                    onRefresh={handleRefresh}
                    darkMode={darkMode}
                    isDisabled={isControlsDisabled}
                    onFullscreenToggle={onFullscreenToggle}
                    isFullscreen={isFullscreen}
                />
            </div>

            {/* Trade creation/editing controls */}
            <div className="ntc-trade-creation-controls">
                {isDraggingLine ? (
                    <span className="ntc-trade-drag-indicator">
                        Dragging {draggingLineName}...
                    </span>
                ) : null}
                {isCreatingTrade ? (
                    <>
                        <span className="ntc-trade-creation-instruction">
                            {tradeCreationInstruction}
                        </span>
                        <button
                            className="ntc-trade-creation-cancel-btn"
                            onClick={onCancelTradeCreation}
                            title="Cancel trade creation"
                        >
                            <CloseIcon fontSize="small" />
                            Cancel
                        </button>
                    </>
                ) : (
                    onStartTradeCreation && (
                        <button
                            className={`ntc-trade-creation-btn ${hasTradeLines ? 'ntc-btn-warning' : ''}`}
                            onClick={handleNewTradeClick}
                            disabled={isControlsDisabled}
                            title={hasTradeLines ? "Start new trade (discards current setup)" : "Create trade by clicking on chart"}
                        >
                            <AddchartIcon fontSize="small" />
                            <span className="ntc-trade-creation-btn-text">
                                {hasTradeLines ? 'New Trade' : 'New Trade'}
                            </span>
                        </button>
                    )
                )}
            </div>

            <ConfirmationModal
                isOpen={isConfirmOpen}
                onClose={() => setIsConfirmOpen(false)}
                onConfirm={handleConfirmNewTrade}
                title="Start New Trade?"
                message="This will discard your current trade setup. Are you sure you want to proceed?"
                confirmText="Start New Trade"
                isWarning={true}
            />
        </div>
    );
};

export default ChartToolbar;
